module.exports = __webpack_public_path__ + "static/media/chaxuanzhong@3x.6ed89ab6.png";